<template>
  <div>
    <div class="content-message" v-if="isCookie"> 
				<div class="content-message-cont">
					<div class="content-message-cont-text">
						{{ $t('cookie.text') }}
					</div>
					<div class="content-message-cont-btn">
						<div class="content-message-cont-btn-leftBtn">
							<button class="btn" @click="manageCookies">
								<!-- <strong>{{ $t('cookie.leftBtn') }}</strong> -->
								 {{ $t('cookie.leftBtn') }}
							</button>
							<button class="btn1" @click="onlyCookies">
								<!-- <strong>{{ $t('cookie.rightBtnLeft') }}</strong> -->
								 {{ $t('cookie.rightBtnLeft') }}
							</button>
							<button class="btn2" @click="allCookies">
								<!-- <strong>{{ $t('cookie.rightBtnRight') }}</strong> -->
								 {{ $t('cookie.rightBtnRight') }}
							</button>
						</div>
					</div>
				</div>
			</div>
			<el-dialog
				:visible.sync="isCookieChild"
				:width="dialogWidth"
				center
				custom-class="cookie-dialog"
				:before-close="handleClose"
				:close-on-click-modal="true"
				:close-on-press-escape="true"
			>
				<div class="cookie-dialog-title">
					<strong>{{ $t('cookie.child.title') }}</strong>
				</div>
				<div class="cookie-dialog-content">{{ $t('cookie.child.text') }}</div>
				<div class="cookie-dialog-btnTopParent">
					<button class="btn3">{{ $t('cookie.child.btnTop') }}</button>
				</div>
				<div class="cookie-dialog-bottom">
					<div class="cookie-dialog-bottom-title">
						<strong>
							{{ $t('cookie.child.textBottomTitle') }}
						</strong>
					</div>
					<div class="cookie-dialog-bottom-content">
						<div class="cookie-dialog-bottom-content-item" v-for="(group, i) in groups" :key="i">
              <button class="cookie-dialog-bottom-content-head" @click="toggle(i)" :aria-expanded="openIndex === i">
                  <!-- <span class="cookie-dialog-bottom-content-icon" :class="{ open: openIndex === i }">+</span> -->
									<span class="cookie-dialog-bottom-content-icon">
										<i class="el-icon-plus" v-if="openIndex !== i"></i>
										<i class="el-icon-minus" v-else></i>
									</span>
                  <span class="cookie-dialog-bottom-content-name">{{ group.name }}</span>
                  <span class="cookie-dialog-bottom-content-spacer"></span>
                  <label class="cookie-dialog-bottom-content-switch">
                    <el-switch
											v-if="i !== 0"
											v-model="group.switchValue"
											active-color="#64715d"
											inactive-color="#d9d9d9">
										</el-switch>
                  </label>
              </button>
              <div class="cookie-dialog-bottom-content-body" v-show="openIndex === i">
                  <p v-for="(p, idx) in group.paragraphs" :key="idx">{{ p }}</p>
              </div>
            </div>
					</div>
				</div>
				<span slot="footer" class="dialog-footer">
					<button class="btn3" @click="closeCookies">{{ $t('cookie.child.btnBottom') }}</button>
				</span>
			</el-dialog>
  </div>
</template>
<script>
export default {
  name: 'Cookies',
  data() {
    return {
      isCookie: true, //是否显示cookie
			isCookieChild: false,
			dialogVisible: false,
			openIndex: 0,
			windowWidth: window.innerWidth, // 添加窗口宽度数据属性
			groups: [
        {
            name: this.$t('cookie.child.groupsList.group1.name'),
            always: true,
            enabled: true,
            paragraphs: [
                this.$t('cookie.child.groupsList.group1.paragraphs'),
                this.$t('cookie.child.groupsList.group1.paragraphs1')
						],
						switchValue:false,
        },
        {
            name: this.$t('cookie.child.groupsList.group2.name'),
            always: true,
            enabled: true,
            paragraphs: [
                this.$t('cookie.child.groupsList.group2.paragraphs'),
                this.$t('cookie.child.groupsList.group2.paragraphs1')
						],
						switchValue:false,
        },
        {
            name: this.$t('cookie.child.groupsList.group3.name'),
            always: true,
            enabled: true,
            paragraphs: [
                this.$t('cookie.child.groupsList.group3.paragraphs'),
                this.$t('cookie.child.groupsList.group3.paragraphs1')
						],
						switchValue:false,
        },
        {
            name: this.$t('cookie.child.groupsList.group4.name'),
            always: true,
            enabled: true,
            paragraphs: [
                this.$t('cookie.child.groupsList.group4.paragraphs')
						],
						switchValue:false,
        }
      ]
    }
	},
	computed: {
    dialogWidth() {
			// 使用 data 中的 windowWidth 而不是直接使用 window.innerWidth
      if (this.windowWidth < 768) {
        return '100%';
      } else if (this.windowWidth <= 1200) {
        return '80%';
      } else {
        return '50%';
      }
    }
	},
	mounted() {
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
	},
	beforeDestroy() {
    // 清理事件监听器
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
		handleResize() {
      // 更新 windowWidth 触发计算属性重新计算
      this.windowWidth = window.innerWidth;
    },
		manageCookies () {
			this.isCookieChild = true;
		},
		closeCookies () {
			this.isCookieChild = false;
			const timestamp = new Date().getTime();
      localStorage.setItem('isShowMobileOfficialWebsiteAlert', timestamp);
      this.isCookie = false;
		},
		onlyCookies () {
			const timestamp = new Date().getTime();
      localStorage.setItem('isShowMobileOfficialWebsiteAlert', timestamp);
      this.isCookie = false;
		},
		allCookies () {
			const timestamp = new Date().getTime();
      localStorage.setItem('isShowMobileOfficialWebsiteAlert', timestamp);
			this.isCookie = false;
		},
		handleClose (done) {
			this.isCookieChild = false;
		},
		toggle(idx) {
        this.openIndex = this.openIndex === idx ? -1 : idx;
    },
    save() {
        alert('已保存Cookie偏好设置');
    },
    enableAll() {
        this.groups = this.groups.map(g => ({ ...g, enabled: true }));
    }
  }
}

</script>
<style scoped>
.content-message{
	width: 100%;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 999;
  padding: 10px 20px;
  background-color: #ffffff;
  box-shadow: 0px 13px 45px 0px rgba(210, 210, 210, 0.5);
}
.content-message-cont{
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: space-between;
}
.content-message-cont-text{
	font-size: 14px;
	color: #000000;
	display: flex;
  align-items: center;
	font-family: math;
  font-weight: var(--header-font-weight);
  letter-spacing: var(--heading-spacing);
  text-transform: var(--heading-font-case);
  line-height: var(--heading-line-height);
}
.content-message-cont-btn{
	display: flex;
  justify-content: space-between;
  align-items: center;
}
.content-message-cont-btn-leftBtn{
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}
/* .content-message-cont-btn-leftBtn strong{
	
} */
.content-message-cont-btn-leftBtn button{
	border: none;
  border-radius: .5rem;
  font-weight: 550;
  font-size: .8125rem;
  cursor: pointer;
  height: 1.75rem;
  max-width: 100%;
  overflow: hidden;
  padding: 0 .375rem;
  text-decoration: none;
	/* font-size: 16px; */
	color: rgb(232, 226, 217);
	white-space: nowrap;
	background-color: rgb(66, 43, 32);
	position: relative;
}
.content-message-cont-btn-leftBtn .btn:hover:after,.content-message-cont-btn-leftBtn .btn1:hover:after,.content-message-cont-btn-leftBtn .btn2:hover:after{
  /* background-color: #5a3b2e;
	color: rgb(255, 255, 255); */
	background-image: linear-gradient(90deg, transparent, hsla(0, 0%, 100%, .25), transparent);
  content: "";
  height: 100%;
  left: 150%;
  position: absolute;
  top: 0;
  transform: skew(-20deg);
  width: 200%;
  animation: shineAgain .75s cubic-bezier(.01, .56, 1, 1);
}
/* cookie弹框按钮操作后样式 */
.cookie-dialog{
	border-radius: 30px!important;
}
:deep(.el-dialog__headerbtn .el-dialog__close){
	font-size: 1rem;
  color: #1e1e1e!important;
}
:deep(.el-dialog__body){
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
:deep(.el-dialog__headerbtn:focus .el-dialog__close, .el-dialog__headerbtn:hover .el-dialog__close){
	color: #1e1e1e!important;
}

:deep(.el-dialog__footer){
	text-align: right!important;
}

.cookie-dialog-title{
	font-size: 1.2rem;
	color: #1e1e1e;
}

.cookie-dialog-content{
	font-size: 0.8rem;
	color: #959595;
}
.cookie-dialog-btnTopParent{
}
.cookie-dialog-btnTop{
	background-color: #1e1e1e;
  border-color: #1e1e1e;
  padding: 1% 3%;
  font-size: 0.8rem;
  border-radius: 10px;
  color: #fff;
  width: 20%;
	cursor: pointer;
	display: flex;
  justify-content: center;
  align-items: center;
}
.cookie-dialog-bottom{

}
.cookie-dialog-bottom-title{
	font-size: 1.2rem;
	color: #1e1e1e;
  margin-bottom: 1%;
}

/* .content-message-next{
	width: 60%;
	height: 10vw;
	position: fixed;
	right: 0;
	bottom: 2%;
	z-index: 999;
	padding: 1.5%;
	background-color: #ffffff;
	box-shadow: 0px 13px 45px 0px rgba(210,210,210,0.5);
	border-radius: 30px;	
}
.content-message-next-cont{
	width: 100%;
	height: 100%;
	display: flex;
  flex-direction: column;
	gap: 1vw;
} */
.cookie-dialog-bottom-content-item {
  border: 2px solid #979797;
  overflow: hidden;
}
.cookie-dialog-bottom-content-item:nth-child(1),.cookie-dialog-bottom-content-item:nth-child(2),.cookie-dialog-bottom-content-item:nth-child(3){
	border-bottom: none;
}
.cookie-dialog-bottom-content-item:nth-child(1){
	border-radius: 8px 8px 0px 0px;
}
.cookie-dialog-bottom-content-item:nth-child(4){
	border-radius: 0px 0px 8px 8px;
}

.cookie-dialog-bottom-content-head {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: 0;
  padding: 10px;
  cursor: pointer;
}

.cookie-dialog-bottom-content-icon {
  border-radius: 4px;
  display: inline-grid;
  place-items: center;
  color: #2f3b34;
  font-size: 0.8rem;
}

.cookie-dialog-bottom-content-icon.open {
  transform: rotate(45deg);
}

.cookie-dialog-bottom-content-name {
  font-weight: 700;
  color: #29352d;
}

.cookie-dialog-bottom-content-spacer {
  flex: 1;
}
.cookie-dialog-bottom-content-switch{

}

.cookie-dialog-bottom-content-chip {
  background: #e9f3e8;
  color: #2f3b34;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.cookie-dialog-bottom-content-body {
  background: #fff;
  padding: 10px;
  color: #3a463f;
  line-height: 1.6;
}

.cookie-dialog-bottom-content-body p {
  margin: 0 0 8px;
}
.btn3{
	border: none;
  border-radius: .5rem;
  font-weight: 550;
  font-size: .8125rem;
  cursor: pointer;
  height: 1.75rem;
  max-width: 100%;
  overflow: hidden;
  padding: 0 .375rem;
  text-decoration: none;
	/* font-size: 16px; */
	color: rgb(232, 226, 217);
	white-space: nowrap;
	background-color: rgb(66, 43, 32);
	position: relative;
}
.btn3:not(:disabled):not(.standalone-icon--wrapper):not(.swiper-button-disabled):not(.disabled):not(.btn3--secondary):hover:after{
  background-image: linear-gradient(90deg, transparent, hsla(0, 0%, 100%, .25), transparent);
  content: "";
  height: 100%;
  left: 150%;
  position: absolute;
  top: 0;
  transform: skew(-20deg);
  width: 200%;
  animation: shineAgain .75s cubic-bezier(.01, .56, 1, 1);
}
@media screen and (min-width: 768px) {
	.content-message-cont-btn-leftBtn button{
		max-width: 200px;
		padding:5px 10px;
		margin-right: 10px;
		font-family: math;
		font-weight: var(--header-font-weight);
		letter-spacing: var(--heading-spacing);
    /* font-size: 14px; */
    height: 30px;
	}
	.btn3{
		max-width: 200px;
    padding: 5px 20px;
    margin-right: 10px;
    font-family: math;
    font-weight: var(--header-font-weight);
    letter-spacing: var(--heading-spacing);
    /* font-size: 14px; */
    height: 30px;
	}
}
@media screen and (max-width: 768px) {
	.content-message-cont{
		flex-direction: column;
		gap: 10px;
	}
	.content-message-cont-btn-leftBtn button,.btn3{
		max-width: 200px;
		padding:5px 10px;
		margin-right: 10px;
		font-family: math;
		font-weight: var(--header-font-weight);
		letter-spacing: var(--heading-spacing);
    /* font-size: 14px; */
	}
}
</style>